import React from 'react';
import { ModalBody, ModalNext, GlobalizationChooser } from '@jutro/components';
import { ServiceManager } from '@jutro/services';

function AdacLanguageModal({
    isOpen,
    onResolve,
    onAfterClose
}) {

    const localeService = ServiceManager.getService('locale-service');

    function handleClose() {
        return onResolve();
    }

    return (
        <ModalNext
            isOpen={isOpen}
            onRequestClose={handleClose}
            onAfterClose={onAfterClose}
        >
            <ModalBody autoFocus>   
                <GlobalizationChooser 
                    onLanguageValueChange={localeService.saveLanguage}
                    languageValue={localeService.getStoredLanguage()}
                    languageLabelText="Choose Language"
                    showLocaleSelect={false}
                />
            </ModalBody>
        </ModalNext>
    );
}

export default AdacLanguageModal;